export const onLoadScript = () => {
  if (
    !(
      window.AF_SMART_SCRIPT &&
      typeof window.AF_SMART_SCRIPT.generateOneLinkURL === "function"
    )
  ) {
    throw new Error(
      "AF_SMART_SCRIPT is not loaded or generateOneLinkURL is not a function",
    )
  }

  const oneLinkURL = "https://yellow.onelink.me/HpLh"
  const mediaSource = { keys: ["utm_source"], defaultValue: "paz_charge_web" }
  const campaign = { keys: ["utm_campaign"], defaultValue: "Organic" }
  const custom_ss_ui = { paramKey: "af_ss_ui", defaultValue: "true" }

  // Generate the OneLink URL
  const result = window.AF_SMART_SCRIPT.generateOneLinkURL({
    oneLinkURL,
    afParameters: {
      mediaSource,
      campaign,
      afCustom: [custom_ss_ui],
    },
  })
  return result.clickURL
}
